/**
 * @author vishwadeep.kapoor
 * @Date: 2020-10-08 15:39:54
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-10-13 18:24:17
 */

import { func, shape, bool, arrayOf, string } from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { select_profileJS, select_isBoolean, selectProfile } from './selectors';
import { selectUserDetails, getEvocherOtp } from '../HeaderContainer/selectors';
import { SetEvoucherOtp } from '../HeaderContainer/actions';
import { WalletRegister, AadharRegister, savePasswordChange, userLogout, PhysicalCardActivate } from './actions';
import { saveProfileChange } from '../LoginPage/actions';

/**
 * @class Profile
 */

const ProfileProps = {
  onPasswordChange: func.isRequired,
  onProfileChange: func.isRequired,
  UserDetails: shape({
    isOnlyMerchandise: bool,
    email: string,
    emails: arrayOf(string),
    name: string,
    phone: string,
    date_of_birth: string,
    wedding_anniversary: string,
    image: shape({
      thumb_url: string,
    }),
  }).isRequired,
  getProfile: shape({
    profileResponse: shape({
      success: bool,
      message: string,
    }),
  }).isRequired,
  onUserLogout: func.isRequired,
  history: shape({}).isRequired,
  isLoadingStatus: bool.isRequired,
  passwordUpdateStatus: bool.isRequired,
};

const ProfileMapStateToProps = createStructuredSelector({
  getProfile: selectProfile(),
  UserDetails: selectUserDetails(),
  isLoadingStatus: select_isBoolean('isLoading'),
  passwordUpdateStatus: select_isBoolean('updateStatus'),
});

const ProfileMapDispatchToProps = (dispatch) => ({
  onPasswordChange: (payload) => dispatch(savePasswordChange(payload)),
  onProfileChange: (payload) => dispatch(saveProfileChange(payload)),
  onUserLogout: (history, otherParams) => dispatch(userLogout(history, otherParams)),
});


/**
 * @class CreateAccount
 */

const CreateAccountProps = {
  isLoading: bool.isRequired,
  history: shape({}).isRequired,
  WalletRegisterSubmit: shape({}).isRequired,
  AadharRegisterSubmit: shape({}).isRequired,
  UserDetails: shape({}).isRequired,
  onWalletRegister: func.isRequired,
  onAadharRegister: func.isRequired,
  onPhysicalCardActivate: func.isRequired,
};

const CreateAccountMapDispatchToProps = (dispatch) => ({
  onWalletRegister: (history) => dispatch(WalletRegister(history)),
  onAadharRegister: (history) => dispatch(AadharRegister(history)),
  onPhysicalCardActivate: (payload, otherParams) => dispatch(PhysicalCardActivate(payload, otherParams)),
});

const CreateAccountMapStateToProps = createStructuredSelector({
  isLoading: select_isBoolean('isLoading'),
  WalletRegisterSubmit: select_profileJS('walletRegisterSubmit'),
  AadharRegisterSubmit: select_profileJS('aadharRegisterSubmit'),
  UserDetails: selectUserDetails(),
});

/**
 * @class ActivateAccount
 */
const ActivateAccountProps = {
  isLoading: bool.isRequired,
  history: shape({}).isRequired,
  CardActivate: shape({}).isRequired,
  onPhysicalCardActivate: func.isRequired,
};

const ActivateAccountMapDispatchToProps = (dispatch) => ({
  onPhysicalCardActivate: (payload, otherParams) => dispatch(PhysicalCardActivate(payload, otherParams)),
});

const ActivateAccountMapStateToProps = createStructuredSelector({
  isLoading: select_isBoolean('isLoading'),
  CardActivate: select_profileJS('cardActivate'),
});


/**
 * @class ProfileNavigation
 */

const ProfileNavigationProps = {
  isOnlyMerchandise: bool,
  history: shape({}).isRequired,
  EvoucherOtp: shape({}).isRequired,
  onUserLogout: func.isRequired,
  onSetEvoucherOtp: func.isRequired,
};

const ProfileNavigationMapDispatchToProps = (dispatch) => ({
  onUserLogout: (history, otherParams) => dispatch(userLogout(history, otherParams)),
  onSetEvoucherOtp: (payload) => dispatch(SetEvoucherOtp(payload)),
});

const ProfileNavigationMapStateToProps = createStructuredSelector({
  UserDetails: selectUserDetails(),
  EvoucherOtp: getEvocherOtp(),
});

export {
  ProfileProps, ProfileMapStateToProps, ProfileMapDispatchToProps,
  CreateAccountProps, CreateAccountMapStateToProps, CreateAccountMapDispatchToProps,
  ActivateAccountProps, ActivateAccountMapStateToProps, ActivateAccountMapDispatchToProps,
  ProfileNavigationProps, ProfileNavigationMapStateToProps, ProfileNavigationMapDispatchToProps,
};



// WEBPACK FOOTER //
// client/containers/Profile/profileDataHandler.js